import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import type { BlockViewProps } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/CallToAction/styles.module.css';
import './calltoaction.scss';
import type { CallToActionData } from '@redturtle/qubicaamf-theme/components/Blocks/CallToAction/schema';

import config from '@plone/registry';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';

type Props = BlockViewProps & {
  data: CallToActionData;
};

export default function View({ data, className, style, content }: Props) {
  const Container = config.getComponent('Container').component || 'div';
  return (
    <section
      className={cx('block-calltoaction', styles.block, className)}
      style={style}
      aria-label={data.title}
    >
      <Container
        className={cx('block-calltoaction-container', styles.container)}
      >
        {data.title && (
          <h2 className={cx('block-calltoaction-title', styles.title)}>
            {data.title}
          </h2>
        )}
        {data.text && (
          <div className={cx('block-calltoaction-text', styles.text)}>
            <TextBlockView data={{ value: data.text ?? {} }} />
          </div>
        )}
        {data.linkHref?.[0] && (
          <CTA
            href={data.linkHref[0]['@id']}
            openLinkInNewTab={false}
            ctaButtonStyle={data.ctaButtonStyle}
            linkIcon={data.linkIcon}
            cta_color={data.cta_color}
            product_id={content['@type'] === 'Product' ? content.UID : null}
          >
            {data.linkTitle}
          </CTA>
        )}
      </Container>
    </section>
  );
}
